import React from "react";
import { prismicAlgoliaIndexName } from "../../utils/constants";
import SearchBox from "../../components/search/search-box/search-box";
import { Configure, InstantSearch } from "react-instantsearch-core";
import { algoliaClient } from "../search/config";

export default () => {
  return (
    <InstantSearch
      searchClient={algoliaClient}
      indexName={prismicAlgoliaIndexName}
    >
      <SearchBox submitAction="urlNavigate" />
      <Configure clickAnalytics />
    </InstantSearch>
  );
};
